<script>
import { mapGetters } from "vuex";
import popup from "@/components/mixins/popup";
import sliderOption from "../popups/content/slider.vue";
import reporter from "@/components/mixins/analysis/sceneBgSetting";

export default {
  mixins: [popup, reporter],
  components: {
    sliderOption,
  },
  data() {
    return {
      ranges: [
        {
          bar: 0, // 0 - 100
          name: "blur",
          alias: "模糊",
          barLength: 0,
          isShow: true,
          isLastMove: false,
        },
        {
          bar: 0, // 0 - 100
          name: "opacity", // 其实这里的英文应该用 transparent
          alias: "透明度",
          barLength: 0,
          isShow: true,
          isLastMove: false,
        },
      ],
      rangeLength: 170,
      moveStack: [],
      oldBgData: {
        blur: null,
        opacity: null,
      },
      rangeLimits: {
        blur: [0, 100],
        opacity: [0, 1],
      },

      zoomScales: [
        { num: 1.25, type: "zoomIn", start: 1, end: 1.25, active: false },
        { num: 1.5, type: "zoomIn", start: 1, end: 1.5, active: false },
        { num: 1.75, type: "zoomIn", start: 1, end: 1.75, active: false },
        { num: 2, type: "zoomIn", start: 1, end: 2, active: false },
        { num: 1, type: "none", start: 1, end: 1, active: false },
        { num: 1.25, type: "zoomOut", start: 1.25, end: 1, active: false },
        { num: 1.5, type: "zoomOut", start: 1.5, end: 1, active: false },
        { num: 1.75, type: "zoomOut", start: 1.75, end: 1, active: false },
        { num: 2, type: "zoomOut", start: 2, end: 1, active: false },
      ],
      isShowZoomScaleMenu: false,
      zoomActiveOption: {},
      oldZoomData: {
        scale: {},
        duration: 0,
      },

      layings: {
        fill: { text: "填充" },
        fit: { text: "适应" },
        stretch: { text: "拉伸" },
        tile: { text: "平铺" },
      },
      currLaying: "fill",
    };
  },
  computed: {},
  watch: {
    "boxData.judgeBox": {
      handler(val) {
        if (val) {
          let bg = this.SelectScenes_Msg.getBackground();

          this.updateZoomOptionsView(
            this.SelectScenes_Msg.background.zoomOptions || {}
          );

          this.oldZoomData.scale = this.zoomActiveOption;
          this.$nextTick(() => {
            if (this.$refs.sliderRef) {
              this.oldZoomData.duration = this.$refs.sliderRef.val - 0;
            }
          });

          this.setCurrLaying();
        } else {
          // 背景变焦埋点
          if (
            this.oldZoomData.scale.type !== this.zoomActiveOption.type ||
            this.oldZoomData.scale.num !== this.zoomActiveOption.num
          ) {
            this.report(this.zoomActiveOption.type + this.zoomActiveOption.num);
          }

          if (
            this.$refs.sliderRef &&
            this.oldZoomData.duration !== this.$refs.sliderRef.val - 0
          ) {
            this.report("zoomDuration");
          }

          // 关闭选项菜单
          this.isShowZoomScaleMenu = false;
        }
      },
    },
    "SelectScenes_Msg.background.zoomOptions": {
      handler(val) {
        this.updateZoomOptionsView(val);
      },
      deep: true,
    },
  },

  created() {
    this.$watch(
      function () {
        return this.ranges[0].bar;
      },
      function (val) {
        this.SelectScenes_Msg.setBackgroundBlur(val, false);
      }
    );

    this.$watch(
      function () {
        return this.ranges[1].bar;
      },
      function (val) {
        this.SelectScenes_Msg.setBackgroundOpacity(this.getOpacity(val), false);
      }
    );

    this.$bus.on("timeline_play_scenes", (data) => {
      let { nowTime, isPlay } = data;
      // eve('timeline_play_scenes', null, data);
      this.TOOL.eve.emit("timeline_play_scenes", data);
    });

    this.$bus.on("timeline_play_all", (data) => {
      let { nowTime, isPlay } = data;
      this.TOOL.eve.emit("timeline_play_all", null, data);

      this.onPlayAll(data);
    });

    /* this.$bus.on('preview_mouseup', (data) => {
      // this.onlyMouseUp = true;
      const $playerVideos = this.TOOL.player.ele.find('video');
      $playerVideos.each((index, el) => {
        el && !el.paused && el.pause();
      });
      const handler = (frame, scenesId) => {
        let currScene = this.TOOL.getScenesIdData(scenesId);
        let currVideo = currScene.background.element.player.find('video')[0];
        if (currVideo && this.isVideoPlay) {
          let scenePlayTime = (frame || 0) / this.TOOL.option.frameRate;
          let startTime = currScene.background.data.videoStartTime || 0;
          // let endTime = currScene.background.data.videoEndTime || 1;
          currVideo.currentTime = scenePlayTime + startTime;
          currVideo.loop = true;
          currVideo.play()
            .catch(err => {
              console.warn(err.message);
              throw err.message;
            });
        }
        // this.onlyMouseUp = false;
        this.TOOL.eve.off('playByFrame', handler);
      };
      this.TOOL.eve.on('playByFrame', handler);
    }); */

    this.$bus.on("preview_mousedown", (data) => {
      const $playerVideos = this.TOOL.player.ele.find("video");
      $playerVideos.each((index, el) => {
        el && !el.paused && el.pause();
      });
    });

    // this.$bus.on('spritesFlagTime', ({ enterTime } = {}) => {
    //
    // });

    // this.$bus.on('timelineFlag_close', (data) => {
    //
    // });

    this.$bus.on("bgLayingSetting.updateLaying", this.setCurrLaying);

    this.$bus.on("spriteAdded_vue", (scene, { spriteType } = {}) => {
      if (spriteType !== "background") {
        return;
      }

      let bgProps = scene.background.data;
      if (bgProps.type === "Color") {
        this.$store.commit("del_vipSprites", { id: "BG-" + scene.id });
      }
    });
  },
  mounted() {},
  methods: {
    onSliderClicked(item, ev) {
      let sliderRect = ev.currentTarget.getBoundingClientRect();
      let button = $(ev.currentTarget).find(".slider__button");
      let pos = ev.clientX - sliderRect.left;
      button[0].style.left = pos + "px";
      this.setBar({
        name: item.name,
        pos: pos,
      });

      this.setMoveStack(item.name);
    },

    setMoveStack(itemName) {
      let len = this.ranges.length;
      this.ranges.forEach((item) => {
        if (itemName === item.name) {
          item.isLastMove = true;
          let arr =
            item.name === this.moveStack[this.moveStack.length - 1]
              ? this.moveStack
              : [...this.moveStack, item.name];
          this.moveStack = arr.slice(-len);
          // console.log({moveStack: this.moveStack})
        } else {
          item.isLastMove = false;
        }
      });
    },

    onDragged({ el, deltaX, offsetX, offsetY, clientX, first, last } = {}) {
      let runwayRect = this.getRunwayRect(el.dataset.name) || {};
      let { rangeLength } = this;
      let pos = 0;

      if (first) {
        return;
      }
      if (last) {
        this.setMoveStack(el.dataset.name);
        return;
      }

      let l = +window.getComputedStyle(el)["left"].slice(0, -2) || 0;

      if ((l <= 0 && deltaX < 0) || clientX < runwayRect.left) {
        pos = 0;
      } else if (
        (l >= rangeLength && deltaX > 0) ||
        clientX > runwayRect.right
      ) {
        pos = rangeLength;
      } else {
        pos = l + deltaX;
      }
      if (pos < 0) {
        pos = 0;
      }
      if (pos > rangeLength) {
        pos = rangeLength;
      }
      el.style.left = pos + "px";
      this.setBar({
        name: el.dataset.name,
        pos: pos,
      });
    },
    getRunwayRect(name) {
      let elem = (this.$refs.runway.filter((el) => name === el.dataset.name) ||
        [])[0];
      return elem && elem.getBoundingClientRect();
    },
    setBar({ name, pos } = {}) {
      let item = this.ranges.filter((range) => range.name === name)[0];
      item.barLength = pos;
      item.bar = ((pos / this.rangeLength) * 100) | 0;
    },
    getRangeBy(name) {
      return (this.ranges.filter((r) => r.name === name) || [])[0];
    },
    getOpacity(transparence) {
      return (1 - transparence / 100).toFixed(2) - 0;
    },
    updateRanges() {
      const vm = this;
      let bg = this.SelectScenes_Msg.getBackground();
      // let rangeBlur = this.getRangeBy('blur');
      // let rangeOpacity = this.getRangeBy('opacity');
      // rangeBlur.bar = bg.data.blur - 0;
      // rangeOpacity.bar = Math.round((1 - bg.data.opacity) * 100);
      this.ranges.forEach((r, i) => {
        if (bg.data[r.name] < vm.rangeLimits[r.name][0]) {
          bg.data[r.name] = vm.rangeLimits[r.name][0];
        } else if (bg.data[r.name] > vm.rangeLimits[r.name][1]) {
          bg.data[r.name] = vm.rangeLimits[r.name][1];
        }
        if (r.name === "blur") {
          r.bar = bg.data.blur - 0;
        }
        if (r.name === "opacity") {
          r.bar = Math.round((1 - bg.data.opacity) * 100);
        }
        let pos = (r.bar / 100) * this.rangeLength;
        this.$refs.sliderButton[i].style.left = pos + "px";
        r.barLength = pos;
      });

      // rangeBlur.isShow = bg.type !== 'Color';
    },
    onPlayAll(data) {
      const vm = this;
      let _time = data.time;
      const $playerVideos = this.TOOL.player.ele.find("video");
      const currVideo = this.TOOL.selectedScenes.background.element.player.find(
        "video"
      )[0];
      this.showingSceneId = "";

      const handler = (frame, scenesId) => {
        if (this.showingSceneId === scenesId) {
          return;
        }
        let currScene = this.TOOL.getScenesIdData(scenesId);
        let currVideo = currScene.background.element.player.find("video")[0];
        let startTime = currScene.background.data.videoStartTime || 0;
        let endTime =
          currScene.background.data.videoEndTime ||
          (currVideo || {}).duration ||
          1;

        if (data.isPlay) {
          this.showingSceneId = scenesId;
          play(
            currVideo,
            (frame || 0) / this.TOOL.option.frameRate,
            startTime,
            endTime
          );
        } else {
          pauseAll();
        }
      };

      if (!this.playHandler) {
        this.playHandler = handler;
      }

      if (data.isPlay) {
        this.isVideoPlay = this.TOOL.isVideoPlay = true;
        this.TOOL.eve.on("playByFrame", this.playHandler);
      } else {
        this.TOOL.eve.off("playByFrame", this.playHandler);
        pauseAll.call(this);
        this.isVideoPlay = this.TOOL.isVideoPlay = false;
      }

      function play(video, sec, startTime = 0, endTime = 1) {
        if (!video) {
          return;
        }
        var isPlaying =
          video.currentTime >= 0 &&
          !video.paused &&
          !video.ended &&
          video.readyState > 2;
        if (video && !isPlaying && video.paused) {
          let scenePlayTime = sec || _time || 0;

          video.onTimeUpdateVue = () => {
            if (
              $(video).is(":visible") &&
              (video.currentTime >= endTime ||
                video.currentTime <= startTime) &&
              vm.isVideoPlay
            ) {
              video.currentTime = startTime;
              video.play();
            }
          };
          video.removeEventListener("timeupdate", video.onTimeUpdateVue);
          video.addEventListener("timeupdate", video.onTimeUpdateVue);

          let ct = scenePlayTime + startTime;
          if (ct > endTime) {
            ct %= endTime - startTime;
            ct += startTime;
          }
          video.currentTime = ct;
          // video.loop = true;
          video.play().catch((err) => {});
        }
      }

      this.play = play;

      function pause(video) {
        video && video.pause();
      }

      function pauseAll() {
        $playerVideos.each((index, el) => {
          el && el.pause();
          el &&
            el.removeEventListener(
              "timeupdate",
              (el || currVideo || {}).onTimeUpdateVue
            );
        });
      }
    },
    editorSetBg() {
      const vm = this;
      let newBgData = {};
      newBgData.blur = vm.getRangeBy("blur").bar;
      newBgData.opacity = vm.getOpacity(vm.getRangeBy("opacity").bar);
      let hasChange = false;

      vm.moveStack.forEach((name) => {
        if (vm.oldBgData[name] !== newBgData[name]) {
          hasChange = true;
          if (name === "blur") {
            vm.SelectScenes_Msg.setBackgroundBlur(newBgData.blur, true, true);
          }
          if (name === "opacity") {
            vm.SelectScenes_Msg.setBackgroundOpacity(
              newBgData.opacity,
              true,
              true
            );
          }

          vm.report(name);

          // let bg = JSON.parse(JSON.stringify(vm.SelectScenes_Msg.getBackground()));
          // bg.data[name] = newBgData[name];

          // 用于撤回操作，此值为true时，表示只是更新背景，不显示视频加载提示
          // bg.data.onlyUpdate = true;

          // vm.SelectScenes_Msg.setBackground(bg, null, true, { update: true });
        }
      });

      hasChange && this.$bus.emit("bgSetting.updateLeftSide");
    },

    test() {
      // let bg = JSON.parse(JSON.stringify(this.SelectScenes_Msg.getBackground()));
      // bg.data.url = 'https://resources.laihua.com/2018-10-11/f7c69820-cd08-11e8-9456-8fb4d11b3c4c.mp4'
      // //'x_https://library.powtoon.co/library/asset/15375/skyscrappers.mp4'; //'https://clipchamp.com/wp-content/uploads/2018/09/Travel-Feel-completely-free-Made-with-Clipchamp.mp4?_=1';
      // bg.type = 'Video';
      // bg.resourceId = 'k';
      // bg.fileType = null;
      // this.SelectScenes_Msg.setBackground(bg);
    },

    /**
     * 调用引擎中的方法
     */
    setZoomDuration(sec, determinable) {
      if (
        sec - 0 ===
        this.SelectScenes_Msg.background.zoomOptions.endTime -
          this.SelectScenes_Msg.background.zoomOptions.startTime
      ) {
        // console.log('same duration')
        return;
      }
      if (!determinable) {
        return;
      }
      this.SelectScenes_Msg.setBgZoom(
        true,
        {
          endTime: sec,
        },
        true
      );

      this.$bus.emit("bgZoom.playScene");
      this.boxData.judgeBox = true;
      this.openPopups();
    },

    // 快捷唤出视频背景时长弹窗
    onClickBtn() {
      this.$bus.emit("FeaturesPop_close_vue", {
        type: 3,
      });

      this.$bus.emit("bgSetting.buttonClicked", { name: "duration" });

      this.$analysis({
        category: "bg_setting",
        action: "click_edit_video_time",
        label: "设置视频背景_剪裁视频",
      });
    },

    getZoomText(item) {
      if (item.num === 1 || item.num == null) {
        return `焦距不变`;
      }
      let m = {
        zoomIn: "拉近",
        zoomOut: "拉远",
      };
      return `${m[item.type]}${item.num}倍`;
    },

    toggleZoomMenu() {
      this.isShowZoomScaleMenu = !this.isShowZoomScaleMenu;
    },

    /**
     * 调用引擎中的方法
     */
    setZoomScale(item, shouldOpenMenu) {
      if (item.active) {
        // console.log('same')
        return;
      }
      this.SelectScenes_Msg.setBgZoom(
        true,
        {
          startScale: item.start,
          endScale: item.end,
          endTime:
            this.SelectScenes_Msg.background.zoomOptions.endTime ||
            this.SelectScenes_Msg.duration / 1000,
        },
        true
      );

      this.$bus.emit("bgZoom.playScene");
      this.boxData.judgeBox = true;
      this.openPopups();
      this.$nextTick(() => {
        this.isShowZoomScaleMenu = shouldOpenMenu;
      });
    },

    /**
     * 更新弹窗中zoom选项的视图
     */
    updateZoomOptionsView(currentOptions) {
      let val = currentOptions;
      if (!val) {
        return;
      }

      this.zoomScales.forEach((item) => {
        let isActive =
          item.start === val.startScale && item.end === val.endScale;
        if (isActive) {
          this.$set(item, "active", true);
          this.zoomActiveOption = item;
        } else {
          this.$set(item, "active", false);
        }
      });

      this.$nextTick(() => {
        this.$refs.sliderRef &&
          this.$refs.sliderRef.updateValFromOutside(
            (currentOptions || {}).endTime || 0
          );
      });
    },

    startSwapBg() {
      this.$bus.emit("materialPane_vue", { type: "bg" });
      this.close();
      this.$store.commit("save_BgOperation", "swap");
    },
    startRemoveBg() {
      let sceneBgData = this.SelectScenes_Msg.background.data.data || {};
      let bgOpts = {
        // 设置场景背景
        resourceId: null, // 背景资源id
        fileType: null, // 背景资源type
        type: "Color",
        data: {
          color: "#FFFFFF",
          blur: 0,
          opacity: 1,
        },
        zoomActive: false,
      };
      this.SelectScenes_Msg.setBackground(bgOpts, null, true);
    },

    setCurrLaying() {
      this.currLaying = this.SelectScenes_Msg.background.data.laying || "fill";
    },
    showLayingSetting() {
      let rect = this.$el.getBoundingClientRect();
      this.$bus.emit("FeaturesPop_vue", {
        type: 1,
        name: "bgLayingSetting",
        initialX: rect.left + rect.width + 28,
        initialY: rect.top,
        source: this,
      });
    },
    closeChildren() {
      this.$bus.emit("FeaturesPop_close_vue", {
        type: 1,
        name: "bgLayingSetting",
        source: this,
      });
    },
    openPopups() {
      this.$bus.emit("zoomOptions.openPopups", this);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/popupsNew/baseBg.vue